// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SignatureFrejaId_reset-list_opSw2{margin:0;padding:0;list-style:none;display:block}.SignatureFrejaId_uppercase-sm_6BKlm{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.SignatureFrejaId_formContainer_2dna7{max-width:263px;margin:0 auto}", ""]);
// Exports
exports.locals = {
	"reset-list": "SignatureFrejaId_reset-list_opSw2",
	"uppercase-sm": "SignatureFrejaId_uppercase-sm_6BKlm",
	"formContainer": "SignatureFrejaId_formContainer_2dna7"
};
module.exports = exports;
